// Registers dayjs plugins + Monday-first locale (weekStart) at app startup.
import 'utils/dayjs';

import { getMonitoringClient } from 'core/monitoring/monitoring';
import { hotkeyKeyUX, startKeyUX } from 'keyux';
import { configure } from 'mobx';
import { createRoot } from 'react-dom/client';
import { onLCP } from 'web-vitals';

import { getYuzu } from './core/monitoring/Yuzu/Yuzu.utils';

const initHotkeys = () => {
  if (typeof window === 'undefined') {
    return;
  }

  try {
    startKeyUX(window, [hotkeyKeyUX()]);
  } catch (e: unknown) {
    console.error('Error initializing hotkeys', e);
  }
};

export const bootstrap = async (node?: HTMLElement | null) => {
  const monitoringClient = await getMonitoringClient();
  void monitoringClient.init();

  if (!node) {
    throw new Error('No root node provided!');
  }

  try {
    const yuzu = getYuzu();
    yuzu.info('APP_START');

    onLCP((metric) => {
      yuzu.info('LCP', {
        value: metric.value || 0,
      });
    });

    void yuzu.start();
  } catch (e: unknown) {
    console.error(e);
  }

  configure({ enforceActions: 'observed' });

  const root = createRoot(node);

  initHotkeys();

  return {
    monitoringClient,
    root,
  };
};
